export const DEFAULT_LOCALE = 'en'
export const AUTH_TOKEN_COOKIE = 'auth_token'
export const NEW_USER_COOKIE = 'newUser'
export const PURCHASE_CURRENCY_COOKIE = 'purchase_currency'
export const PURCHASE_CURRENCY_SYMBOL_COOKIE = 'purchase_currency_symbol'
export const PURCHASE_SELECTED_PRODUCT_COOKIE = 'purchase_selected_product'
export const PRICES_SELECTED_PLAN_COOKIE = 'prices_selected_plan'
export const PMS_API_PREFIX = '/api/payments/v1'
export const OVERRIDE_COUNTRY_CODE_HEADER = 'override--country-code'

export const DEFAULT_BULK_DOWNLOAD_FORMAT = 'png' as const
export const SUPPORTED_BULK_DOWNLOAD_FORMATS = ['png', 'svg', 'jpeg'] as const

export type BulkDownloadFormat =
	(typeof SUPPORTED_BULK_DOWNLOAD_FORMATS)[number]

export enum UserRoleEnum {
	USER = 'user',
	TRANSLATOR = 'translator',
}

export enum TranslationMappingStyleEnum {
	DOT_NOTATION = 'dot',
	UNDERSCORE_NOTATION = 'underscore',
}

export const DATE_DB_FORMAT = 'MMM dd, yyyy'
export const DATE_EXPIRE_FORMAT = 'MMMM dd, yyyy'
export const DATE_DB_FORMAT_MOBILE = 'd.MM.Y'
